import { Theme } from "@mui/material";
import { alpha } from "@mui/system";

const useStyles = (theme: Theme) => ({
  paper: {
    display: "flex",
    height: "40px",
    padding: "0.5rem 0.75rem",
    flexDirection: "row",
    justifyContent: { xs: "space-between", sm: "center" },
    alignItems: "center",
    paddingLeft: 2,
    borderRadius: 1,
    width: { xs: "100%", sm: "fit-content" },
    gap: 0.5,
    "&:hover": {
      cursor: "pointer",
      backgroundColor: alpha(theme.palette.background.textField, 0.5),
    },
  },
  typography: {
    fontSize: "14px",
    fontWeight: "bold",
    height: "20px",
  },
});

export default useStyles;
